import React from 'react';
import { Card, CardContent } from './ui/card';
import {
  DollarSign,
  Calendar,
  Headphones,
  Truck,
  UserCheck,
  Award
} from 'lucide-react';
import { mockBenefits } from '../data/mock';

const iconMap = {
  'dollar-sign': DollarSign,
  'calendar': Calendar,
  'headphones': Headphones,
  'truck': Truck,
  'user-check': UserCheck,
  'award': Award
};

const Benefits = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Why Choose ATW Against the Wind
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            We're committed to delivering exceptional moving experiences through transparency, professionalism, and care.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {mockBenefits.map((benefit) => {
            const Icon = iconMap[benefit.icon];
            return (
              <Card
                key={benefit.id}
                className="hover:shadow-lg transition-shadow duration-300 border border-gray-200 bg-white"
              >
                <CardContent className="p-6">
                  <Icon className="h-12 w-12 text-brand-blue mb-4" />
                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    {benefit.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {benefit.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Benefits;